import React from 'react';
import { NotFoundError } from '../../components/NotFoundError';

const NotFound = () => <NotFoundError />;

export default NotFound;
